import { useEffect } from "react";

// Content stays visible without animation support. Each entrance runs only once.
export default function useReveal(rootRef, ready) {
  useEffect(() => {
    const root = rootRef.current;
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!ready || !root || !("IntersectionObserver" in window)) return;

    const targets = root.querySelectorAll("[data-reveal]");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        if (!preference.matches) target.classList.add("reveal-in");
        observer.unobserve(target);
      });
    }, { threshold: 0.12 });

    targets.forEach((target) => observer.observe(target));
    const stopMotion = () => {
      if (preference.matches) targets.forEach((target) => target.classList.remove("reveal-in"));
    };
    preference.addEventListener("change", stopMotion);
    return () => {
      observer.disconnect();
      preference.removeEventListener("change", stopMotion);
      targets.forEach((target) => target.classList.remove("reveal-in"));
    };
  }, [rootRef, ready]);
}
